export default __webpack_public_path__ + "static/media/WNo.5-2.782812c9.jpg";